import React, { useContext, useEffect, useState } from "react"
import { Modal } from "react-bootstrap";
import {
  Button,
  InputLabel,
  TextField,
  MenuItem,
  Select,
  Switch,
  FormControlLabel
} from "@mui/material";
import language from "../../../nls/language.json";
import Context from "../../../context/Context";
import '../Combinations.css';

export default function AddProductModal({
  showModalAdd,
  setShowModalAdd,
  handleAddProducts,
  selectedAddProduct,
  grupoProdutos,
  postProduct,
  checkSaveBtn
}) {
  const {
    selectedCountry,
  } = useContext(Context);

  const [newGroup, setNewGroup] = useState(false);

  return (
    <Modal show={showModalAdd} onHide={() => setShowModalAdd(false)}>
      <Modal.Header closeButton>
        <Modal.Title>
          {language[selectedCountry.name].Cadastro.combinacoes.produtos.modal.adicionarProduto.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column">
          <div className="d-flex justify-content-start mb-2">
            <FormControlLabel
              className="d-flex align-items-center"
              label="NOVO GRUPO"
              control={
                <Switch
                  checked={newGroup}
                  onChange={() => setNewGroup(!newGroup)}
                />
              }
            />
          </div>

          <div className="d-flex flex-row">
            <InputLabel className="d-flex flex-column me-1 w-50">
              {language[selectedCountry.name].Cadastro.combinacoes.produtos.modal.adicionarProduto.labels.produto}
              <TextField
                className="mb-3"
                name="prodGrupo_ProdCod"
                required
                fullWidth
                id="outlined-basic"
                placeholder="Nome do Produto"
                onChange={({ target }) => handleAddProducts(target, "PRODUTO")}
              />
            </InputLabel>

            <InputLabel
              className="d-flex flex-column me-1 w-50"
            >
              {language[selectedCountry.name].Cadastro.combinacoes.produtos.modal.adicionarProduto.labels.grupo}
              {newGroup ? (
                <TextField
                  className="mb-3"
                  name="prodGrupo_GrupoNome"
                  required
                  fullWidth
                  id="outlined-basic"
                  placeholder="Nome do Grupo"
                  onChange={({ target }) => handleAddProducts(target, "PRODUTO")}
                />
              ) : (
                <Select
                  className=""
                  value={selectedAddProduct.prodGrupo_GrupoNome}
                  onChange={({ target }) => {
                    handleAddProducts({
                      name: "prodGrupo_GrupoNome",
                      value: target.value
                    }, "PRODUTO")
                  }}
                >
                  {grupoProdutos.map((itemProd, i) => (
                    <MenuItem
                      key={`grupProd-${itemProd.prodGrupo_GrupoNome}-${i}`}
                      value={itemProd.prodGrupo_GrupoNome}
                    >
                      {itemProd.prodGrupo_GrupoNome}
                    </MenuItem>
                  ))}
                </Select>
              )}

            </InputLabel>
          </div>

        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="text"
          sx={{ marginRight: 2 }}
          onClick={() => setShowModalAdd(false)}
        >
          {language[selectedCountry.name].Cadastro.combinacoes.produtos.modal.adicionarProduto.btnCancelar}
        </Button>
        <Button
          variant="contained"
          onClick={() => postProduct(selectedAddProduct)}
          disabled={checkSaveBtn(selectedAddProduct)}
        >
          {language[selectedCountry.name].Cadastro.combinacoes.produtos.modal.adicionarProduto.btnSalvar}
        </Button>
      </Modal.Footer>
    </Modal >
  )
}

